"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_shared_js_1 = require("@tableau/api-shared-js");
const ServiceRegistryUtil_1 = require("../Services/ServiceRegistryUtil");
class ExtensionWorkbookImpl extends api_shared_js_1.WorkbookImpl {
    getAllDataSourcesAsync() {
        const service = api_shared_js_1.ApiServiceRegistry.get(ServiceRegistryUtil_1.ExtensionsRegistryId).getService("data-source-service" /* DataSourceService */);
        return service.getAllDataSourcesAsync().then((result) => {
            const dataSchema = result;
            const dataSources = [];
            // Loop through all data sources and add them.
            Object.values(dataSchema.dataSources).forEach((ds) => {
                dataSources.push(this.createDataSourceFromInfo(ds));
            });
            return dataSources;
        });
    }
    createDataSourceFromInfo(dataSourceInfo) {
        const dataSourceImpl = new api_shared_js_1.DataSourceImpl(dataSourceInfo, ServiceRegistryUtil_1.ExtensionsRegistryId);
        const dataSource = new api_shared_js_1.DataSource(dataSourceImpl);
        dataSourceImpl.initializeWithPublicInterfaces(dataSource);
        return dataSource;
    }
}
exports.ExtensionWorkbookImpl = ExtensionWorkbookImpl;
//# sourceMappingURL=ExtensionWorkbookImpl.js.map